import 'font-awesome/css/font-awesome.min.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Logo from "../../assets/logo-laser.png";
import "../../styles/Header.css";
import employee from '../../class/employee';
import React, { useState } from 'react';

import { useParams } from 'react-router-dom';


const logedEmployee = new employee();

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { order_uuid } = useParams();
 

    const handleLogout = () => {
        logedEmployee.logout();
        navigate('/login');
    }




    const goBackToOrders = () => {
        navigate('/choose_order');
    };

    return (
        <header>
            <div className='header'>
                <div className="logo"> <NavLink to="/">
                    <img src={Logo} alt="Logo" />
                </NavLink>
                </div>
                {/* Riempito dalle pagine con createPortal (es. saldo e medie del dettaglio ordine) */}
                <div id="header-slot" className="header-slot"></div>
                <div className="btn-group">
                    <div className="phone">
                      {/*   {location.pathname !== "/choose_order" && location.pathname !== '/login' && location.pathname !== '/' ? (
                            <button onClick={goBackToOrders} className="btn-indietro">← Indietro</button>

                        )
                            : ""} */}

                        {location.pathname !== '/login' && location.pathname !== '/' ? (
                            <button onClick={handleLogout} className="blue_butt">Log out</button>
                        )
                            : ""}


                    </div>
                  
                </div>
            </div>
          
        </header>

    );

};

export default Header;
